import React, { useEffect, useState, useContext } from "react";
import api from "../api";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import ShareModal from "../components/ShareModal";

export default function EventDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [event, setEvent] = useState(null);
  const { user, loading } = useContext(AuthContext);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [shareUrl, setShareUrl] = useState('');

  useEffect(() => {
    api.get(`/events/${id}/`).then((r) => setEvent(r.data));
  }, [id]);

  const handleRSVP = () => {
    navigate(`/rsvp/event-${id}`);
  };

  const handleGenerate = async () => {
    try {
      const tokenResp = await api.post(`/events/${event.uuid}/generate_rsvp/`);
      setShareUrl(tokenResp.data.url);
      setIsShareModalOpen(true);
    } catch {
      toast.error("Failed to generate link");
    }
  };

  const handleDownload = async () => {
    try {
      const res = await api.get(`/events/${id}/pdf/`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `event-${id}-rsvp.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch {
      toast.error("Failed to download PDF");
    }
  };

  if (loading || !event) {
    return <div className="container" style={{ textAlign: 'center', marginTop: '40px' }}>Loading...</div>;
  }

  return (
    <div className="container animate-fade-in" style={{ padding: '0', overflow: 'hidden' }}>
      <div style={{
        height: '300px',
        backgroundColor: '#e5e7eb',
        position: 'relative'
      }}>
        {event.image ? (
          <img
            src={event.image}
            alt={event.name}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '64px'
          }}>
            📅
          </div>
        )}
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
          padding: '24px',
          color: 'white'
        }}>
          <h1 style={{ margin: 0, fontSize: '32px', color: 'white' }}>{event.name}</h1>
          <div style={{ marginTop: '8px', opacity: 0.9 }}>
            <span>📍 {event.location}</span>
            <span style={{ marginLeft: '16px' }}>🕒 {event.start_date} @ {event.start_time}</span>
          </div>
        </div>
      </div>

      <div style={{ padding: '32px' }}>
        <h3 style={{ marginTop: 0 }}>About this Event</h3>
        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '16px' }}>
          {event.description}
        </p>

        <div style={{
          marginTop: '32px',
          borderTop: '1px solid #e5e7eb',
          paddingTop: '24px',
          display: 'flex',
          gap: '16px'
        }}>
          <button onClick={handleRSVP} style={{ flex: 1, padding: '16px' }}>
            RSVP Now
          </button>

          {(user?.is_staff === true || user?.id === event.user) && (
            <>
              <button className="secondary" onClick={handleGenerate}>Generate Link</button>
              <button className="secondary" onClick={() => navigate(`/events/${event.uuid}/rsvps`)}>View RSVPs</button>
              <button className="secondary" onClick={handleDownload}>Download PDF</button>
            </>
          )}
        </div>
      </div>
      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        url={shareUrl}
      />
    </div>
  );
}
